import {SocialMedia} from '../network/social-media.enum';
import {WebsiteModel} from '../widgets/form-section/website-user-input/website.model';

export default class WebsiteUtils {

  static commonWebsitePrefix = 'https://www.';

  // removes 'https://www.' (and variations) from URL, e.g.: https://www.google.com/abc => google.com/abc
  static removeWebsitePrefix(url: string) {
    return url ? url.replace(/^(https:\/\/www\.|http:\/\/www\.|http:\/\/|https:\/\/|www\.)/, '') : '';
  }

  static removeSpaces(url: string) {
    return url ? url.replace(' ', '') : '';
  }

  static getWebsiteFromEnum(url: string, websiteEnum: WebsiteModel[]): WebsiteModel {
    for (const websiteString in websiteEnum) {
      const website = websiteEnum[websiteString];
      const enumUrl = website['profileUrlPrefix'];
      if (enumUrl && url && url.startsWith(enumUrl)) {
        return website;
      }
    }
    return null;
  }

  static getUserNameFromWebsiteUrl(url: string, website: WebsiteModel): string {
    const enumUrl = website['profileUrlPrefix'];
    if (!url) {
      return '';
    }
    let name = url.replace(enumUrl, '');

    if (name.endsWith('/')) {
      name = name.slice(0, -1);
    }

    // StackOverflow is the only website with urls like:
    // www.stackoverflow.com/users/{username}/{something_else}
    // in other websites, URLs ends with user name
    if (website === SocialMedia.StackOverflow) {
      const i = name.indexOf('/');
      return i > -1 ? name.substr(0, i) : name;
    } else {
      return name;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/website-utils.ts